<template>
  <a-drawer
    :title="detail.remark_name"
    width="1000"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="onClose"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-form-item
        label="剧目资质"
        name="qualification_type"
        :rules="[{ required: true, message: '请选择剧目资质' }]"
      >
        <a-select
          v-model:value="formState.qualification_type"
          placeholder="请选择"
          @change="onQualificationTypeChange"
        >
          <a-select-option :value="1">重点/普通微短剧</a-select-option>
          <a-select-option :value="2">其他微短剧</a-select-option>
        </a-select>
      </a-form-item>

      <template v-if="formState.qualification_type === 1">
        <a-form-item
          label="备案号"
          name="ordinary_record_num"
          :rules="[{ required: true, message: '请输入备案号' }]"
        >
          <a-input
            v-model:value="formState.ordinary_record_num"
            placeholder="剧目资质为重点/普通微短剧时必填"
          />
        </a-form-item>
        <a-form-item
          label="剧目资质证明文件"
          name="qualification_certificate_material_ids"
          :rules="[{ required: true, validator: validatorImage }]"
        >
          <a-form-item-rest>
            <Upload
              accept=".png,.jpg,.gif"
              uploadSource="WxOperation2"
              :fileNumber="1"
              :kbCompareMode="UPLOAD_KB_COMPARE_MODE"
              :kbCompareSize="UPLOAD_MAX_KB"
              :kbCompareError="UPLOAD_SIZE_ERROR"
              :beforeUploadPro="beforeUploadProImage"
              :uploadResult="(fileJson, res, record) => uploadResultSingle('qualification_certificate_material_ids', fileJson, res, record)"
              :fileList="formState.qualification_certificate_material_ids"
              :uploadBucket="$pub.BUCKET_PUB()"
            />
          </a-form-item-rest>
          <div class="form-upload-hint">模板请从微小官网下载。支持 .png .jpg .gif，单文件不超过 10MB</div>
          <div class="form-upload-list" v-if="formState.qualification_certificate_material_ids.length">
            <ImageView
              class="form-upload-item"
              v-for="(item, index) in formState.qualification_certificate_material_ids"
              :key="index"
              :url="$pub.CDN_URL(item.url)"
              :fileJson="item"
              @delete="touchDeleteCover('qualification_certificate_material_ids', index)"
            />
          </div>
        </a-form-item>
      </template>

      <template v-if="formState.qualification_type === 2">
        <a-form-item
          label="剧目制作成本"
          name="cost_of_production"
          :rules="[{ required: true, validator: validatorCost }]"
        >
          <a-input
            v-model:value="formState.cost_of_production"
            placeholder="单位：万元，其他微短剧时必填"
            suffix="万元"
          />
        </a-form-item>
        <a-form-item
          label="成本配置比例情况报告"
          name="cost_commitment_letter_material_ids"
          :rules="[{ required: true, validator: validatorImage }]"
        >
          <a-form-item-rest>
            <Upload
              accept=".png,.jpg,.gif"
              uploadSource="WxOperation1"
              :fileNumber="1"
              :kbCompareMode="UPLOAD_KB_COMPARE_MODE"
              :kbCompareSize="UPLOAD_MAX_KB"
              :kbCompareError="UPLOAD_SIZE_ERROR"
              :beforeUploadPro="beforeUploadProImage"
              :uploadResult="(fileJson, res, record) => uploadResultSingle('cost_commitment_letter_material_ids', fileJson, res, record)"
              :fileList="formState.cost_commitment_letter_material_ids"
              :uploadBucket="$pub.BUCKET_PUB()"
            />
          </a-form-item-rest>
          <div class="form-upload-hint">模板请从微小官网下载。支持 .png .jpg .gif，单文件不超过 10MB</div>
          <div class="form-upload-list" v-if="formState.cost_commitment_letter_material_ids.length">
            <ImageView
              class="form-upload-item"
              v-for="(item, index) in formState.cost_commitment_letter_material_ids"
              :key="index"
              :url="$pub.CDN_URL(item.url)"
              :fileJson="item"
              @delete="touchDeleteCover('cost_commitment_letter_material_ids', index)"
            />
          </div>
        </a-form-item>
      </template>

      <a-form-item
        label="微信审核"
        name="expedited"
        :rules="[{ required: true, message: '请选择是否加急' }]"
      >
        <a-radio-group v-model:value="formState.expedited">
          <a-radio :value="0">不加急</a-radio>
          <a-radio :value="1">加急</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item
        label="剧目制作证明材料"
        name="proof_of_production"
        :rules="[{ required: true, validator: validatorProofList }]"
      >
        <a-form-item-rest>
          <Upload
            accept=".png,.jpg,.gif"
            uploadSource="WxOperationProof"
            :multiple="true"
            :fileNumber="4"
            fileNumberError="最多上传 4 个文件"
            :kbCompareMode="UPLOAD_KB_COMPARE_MODE"
            :kbCompareSize="UPLOAD_MAX_KB"
            :kbCompareError="UPLOAD_SIZE_ERROR"
            :beforeUploadPro="beforeUploadProImage"
            :uploadResult="(fileJson, res, record) => uploadResultMulti('proof_of_production', fileJson, res, record)"
            :fileList="formState.proof_of_production"
            :uploadBucket="$pub.BUCKET_PUB()"
          />
        </a-form-item-rest>
        <div class="form-upload-hint">必填，最多 4 张。支持 .png .jpg .gif，单文件不超过 10MB</div>
        <div class="form-upload-list" v-if="formState.proof_of_production.length">
          <ImageView
            class="form-upload-item"
            v-for="(item, index) in formState.proof_of_production"
            :key="item.uid || index"
            :url="$pub.CDN_URL(item.url)"
            :fileJson="item"
            @delete="touchDeleteCover('proof_of_production', index)"
          />
        </div>
      </a-form-item>

      <a-form-item
        label="版权采买/播出授权证明"
        name="purchase_or_broadcast_authorization_certificate"
        :rules="[{ validator: validatorOptionalImageList }]"
      >
        <a-form-item-rest>
          <Upload
            accept=".png,.jpg,.gif"
            uploadSource="WxOperationPurchase"
            :multiple="true"
            :fileNumber="4"
            fileNumberError="最多上传 4 个文件"
            :kbCompareMode="UPLOAD_KB_COMPARE_MODE"
            :kbCompareSize="UPLOAD_MAX_KB"
            :kbCompareError="UPLOAD_SIZE_ERROR"
            :beforeUploadPro="beforeUploadProImage"
            :uploadResult="(fileJson, res, record) => uploadResultMulti('purchase_or_broadcast_authorization_certificate', fileJson, res, record)"
            :fileList="formState.purchase_or_broadcast_authorization_certificate"
            :uploadBucket="$pub.BUCKET_PUB()"
          />
        </a-form-item-rest>
        <div class="form-upload-hint">选填，最多 4 张。支持 .png .jpg .gif，单文件不超过 10MB</div>
        <div class="form-upload-list" v-if="formState.purchase_or_broadcast_authorization_certificate.length">
          <ImageView
            class="form-upload-item"
            v-for="(item, index) in formState.purchase_or_broadcast_authorization_certificate"
            :key="item.uid || index"
            :url="$pub.CDN_URL(item.url)"
            :fileJson="item"
            @delete="touchDeleteCover('purchase_or_broadcast_authorization_certificate', index)"
          />
        </div>
      </a-form-item>
    </a-form>

    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <Loading :loading="isLoading || isDetailLoading"></Loading>
    <PreviewModal ref="RefPreviewModal"></PreviewModal>
  </a-drawer>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { nextTick } from 'process'
import Loading from '@/components/Loading'
import { wxSave, dramaDetail } from '@/api/copyright'
import PreviewModal from '@/components/preview/PreviewModal'
import { message, Modal } from 'ant-design-vue'
import Pub from '@/utils/public'
import Upload from '@/components/Upload'
import ImageView from '@/components/ImageView'

/** Upload 组件：kbCompareMode 11 = 文件大小（KB）小于等于 kbCompareSize */
const UPLOAD_MAX_KB = 10 * 1024
const UPLOAD_KB_COMPARE_MODE = 11
const UPLOAD_SIZE_ERROR = '单文件大小不能超过 10MB'

const RefPreviewModal = ref(null)
const emit = defineEmits(['success'])
const RefForm = ref(null)
const visible = ref(false)
const isLoading = ref(false)
const isDetailLoading = ref(false)
const detail = ref({})
/** 防止关闭抽屉后详情请求仍回写表单 */
let drawerOpenSeq = 0

const formState = reactive({
  qualification_type: 2,
  expedited: 0,
  ordinary_record_num: undefined,
  cost_of_production: undefined,
  cost_commitment_letter_material_ids: [],
  qualification_certificate_material_ids: [],
  proof_of_production: [],
  purchase_or_broadcast_authorization_certificate: []
})

function urlsToFileList (urls) {
  if (!urls || !Array.isArray(urls)) {
    return []
  }
  return urls.filter(Boolean).map((url, i) => ({
    uid: `saved-${i}-${url}`,
    name: (typeof url === 'string' && url.split('/').pop()) || `file-${i}`,
    status: 'done',
    url
  }))
}

/** 将片库详情接口返回的数据写入表单（与 wxSave 字段一致） */
function fillFormFromDramaData (data) {
  if (!data) {
    return
  }
  formState.qualification_type = data.qualification_type != null ? data.qualification_type : 2
  formState.expedited = data.expedited != null ? data.expedited : 0
  formState.ordinary_record_num = data.ordinary_record_num
  formState.cost_of_production = data.cost_of_production
  formState.cost_commitment_letter_material_ids = []
  formState.qualification_certificate_material_ids = []
  if (data.cost_commitment_letter_material_id) {
    formState.cost_commitment_letter_material_ids = [{ url: data.cost_commitment_letter_material_id }]
  }
  if (data.qualification_certificate_material_id) {
    formState.qualification_certificate_material_ids = [{ url: data.qualification_certificate_material_id }]
  }
  formState.proof_of_production = urlsToFileList(data.proof_of_production)
  formState.purchase_or_broadcast_authorization_certificate = urlsToFileList(
    data.purchase_or_broadcast_authorization_certificate
  )
}

/** 片库详情（与 NewFilmDrawer#getDramaDetail 同源接口） */
function getDramaDetail (row, seq) {
  const id = row && row.id
  if (!id) {
    isDetailLoading.value = false
    message.error('剧目 ID 不存在')
    return
  }
  isDetailLoading.value = true
  dramaDetail({ id })
    .then((res) => {
      if (seq !== drawerOpenSeq) {
        return
      }
      isDetailLoading.value = false
      const { code, data } = res
      if (code === 0 && data) {
        detail.value = { ...row, ...data }
        fillFormFromDramaData(data)
      } else {
        message.error(res.message || '获取详情失败')
      }
    })
    .catch(() => {
      if (seq !== drawerOpenSeq) {
        return
      }
      isDetailLoading.value = false
      message.error('获取详情失败')
    })
}

function showDrawer (data) {
  drawerOpenSeq += 1
  const seq = drawerOpenSeq
  detail.value = data || {}
  visible.value = true
  nextTick(() => {
    resetFormState()
    getDramaDetail(data, seq)
  })
}

function onQualificationTypeChange () {
  if (formState.qualification_type === 1) {
    formState.cost_of_production = undefined
    formState.cost_commitment_letter_material_ids = []
  } else {
    formState.ordinary_record_num = undefined
    formState.qualification_certificate_material_ids = []
  }
  nextTick(() => {
    RefForm.value?.clearValidate([
      'ordinary_record_num',
      'qualification_certificate_material_ids',
      'cost_of_production',
      'cost_commitment_letter_material_ids'
    ])
  })
}

function onClose () {
  if (isLoading.value) {
    return
  }
  drawerOpenSeq += 1
  isDetailLoading.value = false
  resetFormState()
  detail.value = {}
  visible.value = false
}

function resetFormState () {
  RefForm.value?.resetFields()
  formState.qualification_type = 2
  formState.expedited = 0
  formState.ordinary_record_num = undefined
  formState.cost_of_production = undefined
  formState.cost_commitment_letter_material_ids = []
  formState.qualification_certificate_material_ids = []
  formState.proof_of_production = []
  formState.purchase_or_broadcast_authorization_certificate = []
}

function beforeUploadProImage (file) {
  if (!file.type.includes('image')) {
    message.error('请上传图片类型的文件')
    return false
  }
  return true
}

function uploadResultSingle (key, fileJson) {
  if (fileJson.status === 'done') {
    formState[key] = [fileJson]
    RefForm.value?.validateFields([key]).catch(() => {})
  }
}

function uploadResultMulti (key, fileJson) {
  if (fileJson.status === 'done') {
    RefForm.value?.validateFields([key]).catch(() => {})
  }
}

function validatorImage (rule, value) {
  if (!value || value.length === 0) {
    return Promise.reject('请上传')
  }
  return Promise.resolve()
}

function listUploadStatusOk (list) {
  if (!list || !list.length) {
    return false
  }
  return list.every((item) => item.status === undefined || item.status === 'done')
}

function validatorProofList (rule, value) {
  if (!value || value.length === 0) {
    return Promise.reject('请上传剧目制作证明材料')
  }
  if (value.length > 4) {
    return Promise.reject('最多上传 4 个文件')
  }
  if (value.some((item) => item.status === 'uploading')) {
    return Promise.reject('正在上传中，请稍候')
  }
  if (value.some((item) => item.status === 'error')) {
    return Promise.reject('存在上传失败的文件，请删除后重新上传')
  }
  return Promise.resolve()
}

function validatorOptionalImageList (rule, value) {
  if (!value || value.length === 0) {
    return Promise.resolve()
  }
  if (value.length > 4) {
    return Promise.reject('最多上传 4 个文件')
  }
  if (value.some((item) => item.status === 'uploading')) {
    return Promise.reject('正在上传中，请稍候')
  }
  if (value.some((item) => item.status === 'error')) {
    return Promise.reject('存在上传失败的文件，请删除后重新上传')
  }
  return Promise.resolve()
}

function touchDeleteCover (coverKey, index) {
  formState[coverKey].splice(index, 1)
}

function mapListToUrls (list) {
  return (list || []).map((item) => item.url).filter(Boolean)
}

function touchSubmit () {
  RefForm.value
    .validate()
    .then(() => {
      const proofList = formState.proof_of_production || []
      if (!listUploadStatusOk(proofList)) {
        message.error('剧目制作证明材料正在上传中...')
        return
      }
      const purchaseList = formState.purchase_or_broadcast_authorization_certificate || []
      if (purchaseList.length && !listUploadStatusOk(purchaseList)) {
        message.error('版权采买/播出授权证明材料正在上传中...')
        return
      }

      const params = {
        drama_id: detail.value && detail.value.id,
        qualification_type: formState.qualification_type,
        expedited: formState.expedited,
        proof_of_production: mapListToUrls(proofList)
      }

      if (formState.qualification_type === 1) {
        params.ordinary_record_num = formState.ordinary_record_num
        if (formState.qualification_certificate_material_ids.length) {
          const imgs = formState.qualification_certificate_material_ids
          if (!listUploadStatusOk(imgs)) {
            message.error('剧目资质证明文件正在上传中...')
            return
          }
          params.qualification_certificate_material_id = imgs[0].url
        }
      } else {
        params.cost_of_production = String(formState.cost_of_production ?? '')
        if (formState.cost_commitment_letter_material_ids.length) {
          const imgs = formState.cost_commitment_letter_material_ids
          if (!listUploadStatusOk(imgs)) {
            message.error('《成本配置比例情况报告》正在上传中...')
            return
          }
          params.cost_commitment_letter_material_id = imgs[0].url
        }
      }

      const purchaseUrls = mapListToUrls(purchaseList)
      if (purchaseUrls.length) {
        params.purchase_or_broadcast_authorization_certificate = purchaseUrls
      }

      isLoading.value = true
      wxSave(params)
        .then((res) => {
          isLoading.value = false
          const { code } = res
          if (code === 0) {
            message.success('保存成功')
            onClose()
            emit('success')
          } else {
            Modal.error({
              title: '操作错误',
              content: res.message
            })
          }
        })
        .catch(() => {
          isLoading.value = false
          Modal.error({
            title: '操作错误',
            content: '保存失败'
          })
        })
    })
    .catch(() => {})
}

function validatorCost (rule, value) {
  if (value === undefined || value === null || `${value}`.trim() === '') {
    return Promise.reject('请输入剧目制作成本')
  }
  if (!Pub.REG_IS_POSITIVE_INTEGER(value)) {
    return Promise.reject('必须为正整数')
  }
  const n = Number(value)
  if (n < 1 || n > 999999) {
    return Promise.reject('请输入合理范围内的万元整数')
  }
  return Promise.resolve()
}

defineExpose({
  showDrawer
})
</script>

<style lang="less" scoped>
.form-upload-hint {
  padding-top: 6px;
  color: #8d8d8d;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  width: 118px;
  height: 148px;
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
</style>
